import React, { useState } from "react";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { IoPersonSharp } from "react-icons/io5";

const SignIn = ({ onLogin }) => {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(userName, password);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-lg border border-gray-200">
        <div className="text-center mb-6">
          <h1 className="font-bold text-xl text-black">H-LINE CRM</h1>
          <h2 className="mt-4 text-2xl font-semibold text-primary">
            Welcome Back!
          </h2>
          <p className="text-gray-500">Sign in to continue</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 pb-1">
              User Name
            </label>
            <div className="relative">
              <input
                type="text"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                placeholder="Enter your user name"
                className="w-full px-4 py-2 mt-1 border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-primary"
                required
              />
              <button
                type="button"
                className="absolute right-3 top-4 text-black"
              >
                <IoPersonSharp />
              </button>
            </div>
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 pb-1">
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="6+ Characters, 1 Capital letter"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-primary"
                required
              />
              <button
                type="button"
                className="absolute right-3 top-3 text-black"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <IoMdEyeOff /> : <IoMdEye />}
              </button>
            </div>
          </div>
          <button
            type="submit"
            className="w-full py-2 text-white bg-primary rounded-lg flex items-center justify-center"
          >
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default SignIn;
